window.SiteReady(($) => {

  console.log('Init Block: Post Grid');

  document.addEventListener('click', function(e) {
    const link = e.target.closest('.post_filter_item');

    if (link) {
      const filterLinks = document.querySelectorAll('.post_filter_item');

      filterLinks.forEach(el => el.classList.remove('active'));
      link.classList.add('active');

      if (typeof window.refreshPills === 'function') {
        window.refreshPills();
      }
    }
  });

  window.addEventListener('popstate', () => {
    setTimeout(() => {
      const currentUrl = window.location.href;
      const filterLinks = document.querySelectorAll('.post_filter_item');

      filterLinks.forEach(link => {
        link.classList.remove('active');

        if (link.href === currentUrl) {
          link.classList.add('active');
        }
      });

      if (typeof window.refreshPills === 'function') {
        window.refreshPills();
      }
    }, 50);
  });
});